import axios from "axios";
import { Base_URL } from "../url";

export const getApprovalLevels = async () => {
  const res = await axios.get(
    `${Base_URL}/ApprovalMatrixMaster/GetApprovalMatrixLevel`
  );
  return res.data;
};

export const getApprovalTypes = async () => {
  const res = await axios.get(
    `${Base_URL}/ApprovalMatrixMaster/GetApprovalTypeMaster`
  );
  return res.data;
};

export const getBooleanOperations = async () => {
  const res = await axios.get(
    `${Base_URL}/ApprovalMatrixMaster/GetBooleanOperations`
  );
  return res.data;
};
export const getResourceDetails = async (orgId) => {
  const res = await axios.get(
    `${Base_URL}/ApprovalMatrixMaster/GetResourceDetails/${orgId}`
  );
  return res.data;
};

export const getRoleDetails = async (orgId) => {
  const res = await axios.get(
    `${Base_URL}/ApprovalMatrixMaster/GetRoleDetails/${orgId}`
  );
  return res.data;
};

export const insertApprovalMatrix = async (payload) => {
  const res = await axios.post(
    `${Base_URL}/ApprovalMatrixMaster/InsertApprovalData`,
    payload
  );
  return res.data;
};
